import { Dropdown } from "react-bootstrap";
import { ThreeDotsVertical } from "react-bootstrap-icons";

const defaultOrders = [
  {
    id: "#ORD-1001",
    customer: "Abel Tesfaye",
    date: "2026-02-21",
    amount: 1250,
    status: "Delivered",
    payment: "Paid",
  },
  {
    id: "#ORD-1002",
    customer: "Sara Mekonnen",
    date: "2026-02-21",
    amount: 860,
    status: "Pending",
    payment: "Unpaid",
  },
  {
    id: "#ORD-1003",
    customer: "Daniel Bekele",
    date: "2026-02-20",
    amount: 2240,
    status: "Shipped",
    payment: "Paid",
  },
];

export default function RecentOrdersTable({
  orders = defaultOrders,
  loading = false,
}) {
  const getStatusBadge = (status) => {
    switch (status) {
      case "Delivered":
        return "success";
      case "Pending":
        return "warning";
      case "Shipped":
        return "info";
      case "Cancelled":
        return "danger";
      default:
        return "secondary";
    }
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center p-4">
        <div className="spinner-border text-primary" />
      </div>
    );
  }

  if (!orders.length) {
    return (
      <div className="text-center text-muted p-4">No recent orders found.</div>
    );
  }

  return (
    <div className="table-responsive">
      <table className="table align-middle">
        <thead className="table-light">
          <tr>
            <th>Order ID</th>
            <th>Customer</th>
            <th>Date</th>
            <th>Amount</th>
            <th>Status</th>
            <th>Payment</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {orders.map((order) => (
            <tr key={order.id}>
              <td className="fw-semibold">{order.id}</td>
              <td>{order.customer}</td>
              <td>{new Date(order.date).toLocaleDateString()}</td>
              <td>ETB {order.amount.toLocaleString()}</td>
              <td>
                <span className={`badge bg-${getStatusBadge(order.status)}`}>
                  {order.status}
                </span>
              </td>
              <td>
                <span
                  className={`badge ${
                    order.payment === "Paid" ? "bg-success" : "bg-danger"
                  }`}
                >
                  {order.payment}
                </span>
              </td>
              <td>
                <Dropdown align="end">
                  <Dropdown.Toggle
                    variant="light"
                    size="sm"
                    className="border-0 shadow-none"
                  >
                    <ThreeDotsVertical />
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item>View</Dropdown.Item>
                    <Dropdown.Item>Invoice</Dropdown.Item>
                    <Dropdown.Item className="text-danger">
                      Cancel Order
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
